import React from 'react';
import { SettingsStore, AppStore, Stores } from '../store';
import { MoveLeftTransition } from './components';
import { settingsApi } from '../api-layer';
import { ToggleSwitch } from './ui';
import { appActions } from '../action';
import changeCase from 'change-case';
import _ from 'lodash';
import { Input } from './input';
import { inject, observer } from 'mobx-react';
import { webRtcDisabled } from '../socket';
import { Button } from './button';
import styled from '../styles/styled-components';
import { Link } from '@reach/router';

const ButtonGroup = styled.div`
  button + button {
    margin-right: 5px;
  }
`;

class RadioGroup extends React.Component<
  {
    label: string;
    options: string[];
    default: string;
    onChange?: (newSelected: string) => any;
  },
  { selected: string }
> {
  constructor(props) {
    super(props);
    this.state = {} as any;
  }
  componentDidMount() {
    this.setState({ selected: '' });
  }
  setSelected(option: string) {
    if (this.state.selected !== option) {
      this.setState({ selected: option });
      this.props.onChange(option);
    }
  }
  render() {
    //<Button onClick={() => {this.setState({selected: opt})}} active={this.state.selected == opt}>{opt}</Button>
    return (
      <div style={{ marginBottom: 10 }}>
        <label className="control-label">{this.props.label}</label> <br />
        <ButtonGroup>
          {this.props.options.map((opt, i) => {
            return (
              <Button
                key={i}
                onClick={() => {
                  this.setSelected(opt);
                }}
                primary={
                  this.state.selected == opt ||
                  (!this.state.selected && this.props.default == opt)
                }
                content={opt}
              />
            );
          })}
        </ButtonGroup>
      </div>
    );
  }
}

type SettingsPageOwnProps = {};
type SettingsPageStoreProps = { settingsStore: SettingsStore };
type SettingsPageProps = SettingsPageOwnProps & SettingsPageStoreProps;
type SettingsPageState = {
  newSettings?: { [key: string]: any };
  restartConfirm?: boolean;
};

class SettingsPageComp extends React.Component<
  SettingsPageProps,
  SettingsPageState
> {
  settingNames = {
    UseWebServer: 'Use web server',
    WebServerPort: 'Web server port',
    WebFilePath: 'Web file path',
    TaskServerPort: 'Task server port',
    SkipHostNameResolve: 'Skip network hostname resolve',
    VncPort: 'VNC server port',
    VncProxyPort: 'VNC server proxy port',
    VncPass: 'VNC password',
    AllowTerminal: 'Enable Terminal',
  };
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    this.setState({ newSettings: {} });
  }
  restart = () => {
    if (this.state.restartConfirm) {
      //sendCommandToDefault("restartServer")
      settingsApi.restartServer();
      this.setState({ restartConfirm: false });
    } else {
      this.setState({ restartConfirm: true });
    }
  };
  finalizeSettings = () => {
    /*
        _.forIn(this.state.newSettings, (v, k) => {
            settingsApi.changeSetting({k: v})
        }) */
  };
  render() {
    if (!this.props.settingsStore.settings) {
      return <div>Loading settings...</div>;
    }

    let page = [];
    _.forIn(this.props.settingsStore.settings, (v, k) => {
      if (k == 'LoadPlugins') return;
      if (typeof v === 'boolean') {
        page.push(
          <RadioGroup
            key={k}
            onChange={val => {
              this.setState({
                newSettings: _.assign(this.state.newSettings, {
                  [k]: val == 'yes',
                }),
              });
            }}
            label={this.settingNames[k]}
            default={v ? 'yes' : 'no'}
            options={['yes', 'no']}
          />,
        );
      } else {
        page.push(
          <Input
            key={k}
            type="text"
            //label={this.settingNames[k]}
            value={String(v)}
            onChange={e => {
              this.setState({
                newSettings: _.assign(this.state.newSettings, {
                  [k]: (e.target as HTMLInputElement).value,
                }),
              });
            }}
          />,
        );
      }
    });
    return (
      <div className="settings-page">
        {/* JSON.stringify(this.state) */}
        {page}
        <ButtonGroup>
          <Button onClick={this.finalizeSettings} primary content="Save" />
          <Button
            style={{ color: 'red' }}
            onClick={this.restart}
            content={
              this.state.restartConfirm ? 'Confirm Restart' : 'Restart Server'
            }
          />
        </ButtonGroup>
      </div>
    );
  }
}

export const SettingsPage = inject<
  Stores,
  SettingsPageOwnProps,
  SettingsPageStoreProps,
  {}
>(({ settingsStore }) => ({ settingsStore }))(
  observer(SettingsPageComp),
) as React.ComponentClass<SettingsPageOwnProps>;

const settingNames = {
  ToggleWebServer: 'Use web server',
  WebServerPort: 'Web server port',
  WebFilePath: 'Web file path',
  TaskServerPort: 'Task server port',
  SkipHostNameResolve: 'Skip network hostname resolve',
  VncPort: 'VNC server Port',
  VncProxyPort: 'VNC server proxy port',
  VncPass: 'VNC password',
  AllowTerminal: 'Enable terminal',
  TerminalPort: 'Terminal port',
  UseWebcams: 'Enable webcams',
  UpnpEnabled: 'Enable UPNP',
  WebcamPort: 'Webcam streaming port',
  ScreenSharePort: 'Screen share port',
};

function getSettingLabel(setting: string) {
  if (settingNames[setting]) {
    return settingNames[setting];
  } else {
    return changeCase.sentenceCase(setting);
  }
}

interface ModalSettingsOwnProps {
  show: boolean;
}

type ModalSettingsStoreProps = {
  settingsStore: SettingsStore;
  appStore: AppStore;
};

type ModalSettingsProps = ModalSettingsOwnProps & ModalSettingsStoreProps;

interface ModalSettingsState {
  newSettings?: any;
  restartConfirm?: boolean;
}

class ModalSettingsComp extends React.Component<
  ModalSettingsProps,
  ModalSettingsState
> {
  state: ModalSettingsState = {
    restartConfirm: false,
  };

  finalizeSettings = () => {
    let entireNewSettings = _.assign({}, this.props.settingsStore.settings);
    _.forOwn(entireNewSettings, (category, categoryName) => {
      _.forOwn(this.state.newSettings, (newValue, newName) => {
        if (_.some(_.keys(category), settingName => settingName == newName)) {
          category[newName] = newValue;
        }
      });
    });
    console.log(entireNewSettings);
    settingsApi.changeSettings(entireNewSettings);
    /*
        _.forIn(this.state.newSettings, (v, k) => {
            settingsApi.changeSetting({[k]: v})
        }) */
    this.setState({ newSettings: {} });
  };
  restart = () => {
    if (this.state.restartConfirm) {
      //sendCommandToDefault("restartServer")
      settingsApi.restartServer();
      this.state.restartConfirm = false;
    } else {
      this.setState({ restartConfirm: true });
    }
  };
  settingsBody() {
    if (!this.props.settingsStore.settings) {
      return <div className="fixed settings-body" />;
    }

    const s = this.props.settingsStore.settings;
    const ns = this.state.newSettings;
    let displaySettings = [
      _.omit(s.TaskServer, 'Encryption'),
      _.omit(s.Network, 'BindLocal'),
      s.WebServer,
      s.Webcams,
      s.Terminal,
      s.ScreenShareService,
    ];
    let body = [];
    displaySettings.forEach(category => {
      _.forOwn(category, (value, name) => {
        if (_.isBoolean(value)) {
          body.push(
            <ToggleSwitch
              key={name}
              label={getSettingLabel(name)}
              defaultState={value}
              onChange={newValue => {
                this.setState({
                  newSettings: _.assign(this.state.newSettings, {
                    [name]: newValue,
                  }),
                });
              }}
            />,
          );
        } else {
          body.push(
            <Input
              key={name}
              type={name == 'ScreenSharePass' ? 'password' : 'text'}
              //label={getSettingLabel(name)}
              value={value}
              onChange={e => {
                let text = (e.target as HTMLInputElement).value;
                this.setState({
                  newSettings: _.assign(this.state.newSettings, {
                    [name]: text,
                  }),
                });
              }}
            />,
          );
        }
      });
    });
    return (
      <div className="flex settings-body">
        {body}
        <ToggleSwitch
          label="Enable debug page"
          defaultState={this.props.appStore.debugMenu}
          onChange={newValue => appActions.setDebugMenu(newValue)}
        />
        <ToggleSwitch
          label="Disable WebRTC"
          defaultState={webRtcDisabled}
          onChange={newValue => appActions.setWebRtcDisabled(newValue)}
        />
        <Link to="/serverlog" className="label-text">
          Server log
        </Link>
      </div>
    );
  }
  render() {
    return (
      <MoveLeftTransition show={this.props.show} distance={500}>
        <div className="settings-panel">
          <div className="header">settings</div>
          <div className="panel-button-bar">
            <div className="panel-button" onClick={this.finalizeSettings}>
              apply changes
            </div>
            <div className="green-panel-button" onClick={this.restart}>
              {this.state.restartConfirm ? 'confirm restart' : 'restart server'}
            </div>
          </div>
          {/*JSON.stringify(this.state.newSettings*/}
          {this.settingsBody()}
        </div>
      </MoveLeftTransition>
    );
  }
}

export const ModalSettings = inject<
  Stores,
  ModalSettingsOwnProps,
  ModalSettingsStoreProps,
  {}
>(({ appStore, settingsStore }) => ({ appStore, settingsStore }))(
  observer(ModalSettingsComp),
) as React.ComponentClass<ModalSettingsOwnProps>;
